module.exports = __webpack_public_path__ + "static/media/vpower-master-shellbox.77e10315.svg";